import React from 'react'

import backgroundCellsSvg from 'assets/images/sprite/bg_lines.svg'

import { StyledBreakScreenLayout as S } from './BreakScreenLayout.styles'

type TBreakScreenLayoutProps = {
  children: React.ReactNode
  className?: string
}

export const BreakScreenLayout: React.FC<TBreakScreenLayoutProps> = ({
  children,
  className,
}) => (
  <S.Wrapper className={className}>
    <S.BackgroundCells
      svg={backgroundCellsSvg}
      preserveAspectRatio="xMidYMin slice"
    />

    <S.Content>{children}</S.Content>
  </S.Wrapper>
)
